import React, {useState, useEffect, useContext} from 'react';
import {Card, CardHeader, CardBody, Input, Table, Button} from 'reactstrap';
import Loader from 'components/Loader';
import PaginationWrapper from 'components/PaginationWrapper';
import {securityGetUsers} from 'utils/api';
import sortAlphabetically from 'Helpers/sortAlphabetically';
import {sortByValue} from 'Helpers/sortByValue';
import {ErrorContext} from 'contexts/ErrorContext';
import SortableTableHeader from 'components/SortableTableHeader';
import {getAllSources} from 'utils/api/fetchesApi';
import {getProfile} from 'utils/api/authApi';

import FeedsListItem from './FeedsListItem';
import {Link, useHistory} from 'react-router-dom';
import {connect} from 'react-redux';
import './style.scss';
import {SafeToLowerCase} from 'Helpers/safeToLowerCase';

const FeedsList = ({auth}) => {
    let history = useHistory();
    const {handleErrors} = useContext(ErrorContext);

    const [searchValue, setSearchValue] = useState('');
    const [fullSourcesList, setFullSourcesList] = useState(null);
    const [visibleList, setVisibleList] = useState(null);
    const [activeSortProperty, setActiveSortProperty] = useState('name');
    const [activeSortDirection, setActiveSortDirection] = useState('asc');
    const [fetchingData, setFetchingData] = useState(true);
    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [activeMobileSortSelection, setActiveMobileSortSelection] = useState('name-asc');
    const [profile, setProfile] = useState(null);

    useEffect(() => {
        fetchSourcesList();
        fetchProfile();
    }, []);

    const fetchProfile = async() => {
        try {
            let profileData = await getProfile();
            setProfile(profileData.content);
        } catch(err) {
            console.log(err);
        }
    };

    useEffect(() => {
        if(fullSourcesList && visibleList) {
            applyFilters(true, fullSourcesList);
        }
    }, [activeSortProperty, activeSortDirection, searchValue]);

    const applyFilters = (resetPage, list) => {
        let newArr = sortByValue(list, activeSortProperty, activeSortDirection);
        if(searchValue && searchValue.length > 0) {
            let arrFilteredBySearchValue = newArr.filter(item => {
                return SafeToLowerCase(item.attachedName).includes(SafeToLowerCase(searchValue));
            });
            setVisibleList(arrFilteredBySearchValue);
            resetPage && setCurrentPageNumber(1);
        } else {
            setVisibleList(newArr);
            resetPage && setCurrentPageNumber(1);
        }
    };

    const fetchSourcesList = async(refresh) => {
        try {
            !fetchingData && !refresh && setFetchingData(true);
            let data = await getAllSources();

            let dataArr = [...data.content.result];
            if(dataArr && dataArr.length === 0) {
                if(auth.permissions && (auth.permissions.includes('social') || auth.permissions.includes('vs'))) {
                    history.push('/main/globe');
                    return;
                } else if(auth.permissions && auth.permissions.includes('entity')) {
                    history.push('/add-entity');
                    return;
                }
            }
            let initialList = sortByValue(dataArr, 'updatedAt', 'desc');
            setFullSourcesList(dataArr);
            if(!refresh) {
                setVisibleList(initialList);
                // setVisibleList(dataArr.filter((item) => item.attachedAccounts.name.toLowerCase().includes(searchValue.toLowerCase())));
            }
            refresh && applyFilters(!refresh, initialList);
            setFetchingData(false);
        } catch(err) {
            console.log(err);
            handleErrors(err);
            setFetchingData(false);
        }
    };

    const handlePaginationClick = (pageNumber) => {
        setCurrentPageNumber(pageNumber.selected + 1);
    };

    const handleSortSelect = (sortValue) => {
        if(activeSortProperty === sortValue) {
            setActiveSortDirection(activeSortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setActiveSortProperty(sortValue);
            setActiveSortDirection('asc');
        }
    };

    const handleMobileSortSelect = (sortSelection) => {
        let splitArr = sortSelection.split('-');
        if(splitArr.length === 2) {
            setActiveSortProperty(splitArr[0]);
            setActiveSortDirection(splitArr[1]);
        }
        setActiveMobileSortSelection(sortSelection);
    };


    return (
        <div className="d-flex align-items-center flex-column">
            <div className="w-100">
                <div className="fetches__header mt-3 mb-3 d-flex justify-content-between align-items-center">
                    <h1 className="mb-0">Fetches</h1>
                </div>
                {visibleList === null ? (
                    <Loader small text="Fetching news feeds"/>
                ) : (
                    <>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <div className="feeds-container_input flex-grow-1">
                                {fullSourcesList !== null && fullSourcesList.length > 0 && (
                                    <div className="feeds-container-wrapper mb-0">
                                        <Input
                                            style={{height: '35px'}}
                                            onChange={(e) => setSearchValue(e.target.value)}
                                            value={searchValue}
                                            placeholder="Search by name"
                                            type="text"
                                            className="searchInput"
                                        />
                                        {!searchValue ? (
                                            <i
                                                style={{
                                                    position: 'absolute',
                                                    top: '28%',
                                                    bottom: '10.5px',
                                                    right: '11px',
                                                }}
                                                className="fa fa-search search-container_icon"
                                            />
                                        ) : (
                                            <i
                                                style={{
                                                    cursor: 'pointer',
                                                    position: 'absolute',
                                                    top: '28%',
                                                    bottom: '10.5px',
                                                    right: '11px',
                                                }}
                                                onClick={() => setSearchValue('')}
                                                className="fa fa-times-circle search-container_icon"
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                            <div>
                                {auth.permissions && (auth.permissions.includes('social') || auth.permissions.includes('vs')) ?
                                    <Link to="/main/globe">
                                        <Button className="calltoaction-button ml-2" style={{ color: 'white' }}>
                                            Create Fetch
                                        </Button>
                                    </Link>
                                    : auth.permissions.includes('entity') &&
                                    <></>
                                    // <Link to={'/add-entity'}>
                                    //     <Button className="calltoaction-button" style={{ color: 'white' }}>
                                    //         Add entity
                                    //     </Button>
                                    // </Link>
                                }
                            </div>
                        </div>
                        {fullSourcesList && fullSourcesList.length > 0 && (
                            <div className="feeds_sortBy">
                                <span>Sort by</span>
                                <Input onChange={(e) => handleMobileSortSelect(e.target.value)} type="select"
                                       value={activeMobileSortSelection}>
                                    <option value="attachedName-asc">Name (A to Z)</option>
                                    <option value="attachedName-desc">Name (Z to A)</option>
                                    {/*<option value="isSingleUser-desc">Organization Type ('Teams' first)</option>*/}
                                    {/*<option value="isSingleUser-asc">Organization Type ('Single' first)</option>*/}
                                    {/*<option value="timezone-asc">Timezone (A to Z)</option>*/}
                                    {/*<option value="timezone-desc">Timezone(Z to A)</option>*/}
                                    {/*<option value="userTZ">User's TZ (A to Z)</option>*/}
                                    {/*<option value="userTZDescending">User's TZ (Z to A)</option>*/}
                                    <option value="createdAt-desc">Created at (Newest to Oldest)</option>
                                    <option value="createdAt-asc">Created at (Oldest to Newest)</option>
                                    <option value="lastParseTime-desc">Parsed at (Newest to Oldest)</option>
                                    <option value="lastParseTime-asc">Parsed at (Oldest to Newest)</option>
                                    <option value="contentUpdatedAt-desc">Updated at (Newest to Oldest)</option>
                                    <option value="contentUpdatedAt-asc">Updated at (Oldest to Newest)</option>
                                    {/*<option value="feedscount">Feeds Count (1 to 9)</option>*/}
                                    {/*<option value="feedscountDescending">Feeds Count (9 to 1)</option>*/}
                                </Input>
                            </div>
                        )}
                        {/* <div>
                            <Button className="typical-button" style={{ color: 'white' }} onClick={() => reactivateFacebook(true)}>
                                Reactivate Facebook Accounts
                            </Button>
                        </div> */}
                        <div className="table mt-3">
                            {fullSourcesList && fullSourcesList.length > 0 ? (
                                <Table style={{color: '#314784'}} responsive>
                                    <thead className="hidden">
                                    <tr>
                                        <SortableTableHeader
                                            name="Name"
                                            value="attachedName"
                                            activeSortValue={activeSortProperty}
                                            activeSortDirection={activeSortDirection}
                                            handleSelect={() => handleSortSelect('attachedName')}
                                        />
                                        <th>RSS Feed</th>
                                        {auth.isSingleUser &&
                                        <th>Daily Alerts</th>
                                        }
                                        <SortableTableHeader
                                            name="Created At"
                                            value="createdAt"
                                            activeSortValue={activeSortProperty}
                                            activeSortDirection={activeSortDirection}
                                            handleSelect={() => handleSortSelect('createdAt')}
                                        />
                                        <SortableTableHeader
                                            name="Parsed At"
                                            value="lastParseTime"
                                            activeSortValue={activeSortProperty}
                                            activeSortDirection={activeSortDirection}
                                            handleSelect={() => handleSortSelect('lastParseTime')}
                                        />
                                        <SortableTableHeader
                                            name="Updated At"
                                            value="contentUpdatedAt"
                                            activeSortValue={activeSortProperty}
                                            activeSortDirection={activeSortDirection}
                                            handleSelect={() => handleSortSelect('contentUpdatedAt')}
                                        />
                                        <SortableTableHeader
                                            name="Status"
                                            value="status"
                                            small
                                            activeSortValue={activeSortProperty}
                                            activeSortDirection={activeSortDirection}
                                            handleSelect={() => handleSortSelect('status')}
                                        />
                                        <th style={{minWidth: '100px'}}>
                                            Actions
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {fetchingData ? (
                                        <tr>
                                            <td className="mt-5"><Loader/></td>
                                        </tr>
                                    ) : (
                                        <>
                                            {visibleList && visibleList.length > 0 ? (
                                                visibleList.slice((currentPageNumber - 1) * 50, currentPageNumber * 50).map((item, index) => (
                                                    <FeedsListItem
                                                        key={item.id}
                                                        item={item}
                                                        refreshList={fetchSourcesList}
                                                        profile={profile}
                                                        auth={auth}
                                                    />
                                                ))
                                            ) : (
                                                <tr>
                                                    <td className="mt-5">No matching results</td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                    </tbody>
                                </Table>
                            ) : (
                                <p className="mt-5">Add sources to manage them here</p>
                            )}
                        </div>
                        {visibleList && visibleList.length > 50 && (
                            <PaginationWrapper
                                totalPages={Math.ceil(visibleList.length / 50)}
                                handlePageClick={handlePaginationClick}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

const mapStateFromProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateFromProps, null)(FeedsList);
